if (!customElements.get('hn-reference-menu')) {
  customElements.define(
    'hn-reference-menu',
    class extends HTMLElement {
      connectedCallback() {
        this.listenerController?.abort();
        this.listenerController = new AbortController();
        const { signal } = this.listenerController;
        this.items = [...this.querySelectorAll('.hn-reference-header__item--has-children')];
        this.safeCorridorCleanup = new Map();
        this.suppressFocusOpen = false;
        this.onDocumentPointerDown = (event) => {
          if (!this.contains(event.target)) this.closeAll();
        };
        this.items.forEach((item) => {
          const button = item.querySelector('[data-hn-disclosure]');
          item.addEventListener('pointerenter', () => {
            this.cancelSafeCorridor(item);
            button.dataset.hnPointerWasOpen = button.getAttribute('aria-expanded');
            this.open(item);
          }, { signal });
          item.addEventListener('pointerleave', (event) => {
            const panel = item.querySelector('[data-hn-submenu]');
            const trigger = item.querySelector('.hn-reference-header__top-link');
            if (!panel || !trigger) {
              this.close(item);
              return;
            }

            const triggerRect = trigger.getBoundingClientRect();
            const isLeavingDownThroughTrigger = event.clientY >= triggerRect.bottom - 2
              && event.clientX >= triggerRect.left
              && event.clientX <= triggerRect.right;

            if (isLeavingDownThroughTrigger) {
              this.armSafeCorridor(item, trigger, panel);
            } else {
              this.close(item);
            }
          }, { signal });
          item.addEventListener('focusin', () => {
            if (!this.suppressFocusOpen) this.open(item);
          }, { signal });
          item.addEventListener('focusout', (event) => {
            if (!event.relatedTarget || !item.contains(event.relatedTarget)) this.close(item);
          }, { signal });
          button?.addEventListener('pointerdown', () => {
            if (button.dataset.hnPointerWasOpen == null) {
              button.dataset.hnPointerWasOpen = button.getAttribute('aria-expanded');
            }
          }, { signal });
          button?.addEventListener('click', (event) => {
            event.stopPropagation();
            const pointerWasOpen = button.dataset.hnPointerWasOpen;
            delete button.dataset.hnPointerWasOpen;
            if (event.detail > 0 && pointerWasOpen === 'true') {
              this.close(item);
            } else {
              this.open(item);
            }
          }, { signal });
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const item = event.target.closest('.hn-reference-header__item--has-children');
          if (!item) return;
          event.preventDefault();
          event.stopPropagation();
          this.close(item);
          const button = item.querySelector('[data-hn-disclosure]');
          const panel = item.querySelector('[data-hn-submenu]');
          if (button && document.activeElement !== button) {
            this.suppressFocusOpen = true;
            button.focus();
            queueMicrotask(() => {
              this.suppressFocusOpen = false;
            });
          }
        }, { signal });
        document.addEventListener('pointerdown', this.onDocumentPointerDown, { signal });
      }

      disconnectedCallback() {
        this.safeCorridorCleanup?.forEach((cleanup) => cleanup());
        this.safeCorridorCleanup?.clear();
        this.listenerController?.abort();
        this.listenerController = undefined;
      }

      armSafeCorridor(item, trigger, panel) {
        this.cancelSafeCorridor(item);
        const controller = new AbortController();
        const cleanup = () => {
          controller.abort();
          this.safeCorridorCleanup.delete(item);
        };
        this.safeCorridorCleanup.set(item, cleanup);

        document.addEventListener('pointermove', (event) => {
          const triggerRect = trigger.getBoundingClientRect();
          const panelRect = panel.getBoundingClientRect();
          const insidePanel = event.clientX >= panelRect.left
            && event.clientX <= panelRect.right
            && event.clientY >= panelRect.top
            && event.clientY <= panelRect.bottom;
          const insideTrigger = event.clientX >= triggerRect.left
            && event.clientX <= triggerRect.right
            && event.clientY >= triggerRect.top
            && event.clientY <= triggerRect.bottom;
          const insideDownwardCorridor = event.clientX >= triggerRect.left
            && event.clientX <= triggerRect.right
            && event.clientY > triggerRect.bottom
            && event.clientY < panelRect.top;

          if (insidePanel || insideTrigger) {
            cleanup();
            return;
          }
          if (!insideDownwardCorridor) {
            cleanup();
            this.close(item);
          }
        }, { signal: controller.signal });
      }

      cancelSafeCorridor(item) {
        this.safeCorridorCleanup?.get(item)?.();
      }

      open(item) {
        this.items.forEach((candidate) => {
          if (candidate !== item) this.close(candidate);
        });
        const button = item.querySelector('[data-hn-disclosure]');
        const panel = item.querySelector('[data-hn-submenu]');
        button?.setAttribute('aria-expanded', 'true');
        if (panel) {
          panel.inert = false;
          panel.setAttribute('aria-hidden', 'false');
        }
      }

      close(item) {
        this.cancelSafeCorridor(item);
        const button = item.querySelector('[data-hn-disclosure]');
        const panel = item.querySelector('[data-hn-submenu]');
        button?.setAttribute('aria-expanded', 'false');
        if (panel) {
          panel.inert = true;
          panel.setAttribute('aria-hidden', 'true');
        }
      }

      closeAll() {
        this.items.forEach((item) => this.close(item));
      }
    }
  );
}
